import React, { FC, useMemo, useRef, useState } from 'react';

import { Button } from 'devextreme-react/button';
import DataGrid, { Column, FilterRow, Pager, Paging } from 'devextreme-react/data-grid';
import 'devextreme-react/text-area';

import { AppCard, AppLayoutTop } from '../../../../components/appComponents';
import ClaimsProvider from '../../../../components/claimsBlock';
import $createDataSource from '../../../../utils/create-data-souce-instance';
import DeleteModal from './modals/delete';
import AddEditModal from './modals/edit-add';

const TransportPage: FC = () => {
  const [visible, setVisible] = useState<boolean>(false);
  const [openId, setOpenId] = useState<number | null>(null);

  const [visibleDelete, setVisibleDelete] = useState<boolean>(false);
  const [openIdDelete, setOpenIdDelete] = useState<number | null>(null);

  const transportModelDataStore: any = useMemo(() => {
    return $createDataSource('/v1/TransportModel', 'id');
  }, []);

  const refGrid = useRef<DataGrid | null>(null);

  return (
    <div className="container-dev">
      <AppLayoutTop title="Марки транспорта">
        <ClaimsProvider claimsBlock={['CanCreateTransportModel']}>
          <Button
            width={120}
            text="Создать"
            type="default"
            onClick={() => {
              setOpenId(null);
              setVisible(true);
            }}
          />
        </ClaimsProvider>
      </AppLayoutTop>

      <AddEditModal
        visible={visible}
        changeVisible={(show) => {
          if (!show) setOpenId(null);
          setVisible(show);
        }}
        id={openId}
        refresh={() => refGrid.current?.instance.refresh()}
      />

      <DeleteModal
        visible={visibleDelete}
        changeVisible={(show) => setVisibleDelete(show)}
        id={openIdDelete}
        refresh={() => refGrid.current?.instance.refresh()}
      />

      <AppCard>
        <DataGrid
          dataSource={transportModelDataStore}
          showBorders={false}
          loadPanel={{
            enabled: true,
            text: 'Загрузка',
          }}
          ref={refGrid}
          remoteOperations={true}
        >
          <FilterRow visible={false} />
          <Column dataField="name" caption="Наименование" />
          <Column
            allowSorting={false}
            dataField="actions"
            caption=""
            width={150}
            cellRender={(data) => (
              <>
                <ClaimsProvider claimsBlock={['CanEditTransportModel']}>
                  <Button
                    icon="edit"
                    type="default"
                    stylingMode="text"
                    onClick={() => {
                      setOpenId(data.key);
                      setVisible(true);
                    }}
                  />
                </ClaimsProvider>
                <ClaimsProvider claimsBlock={['CanDeleteTransportModel']}>
                  <Button
                    icon="trash"
                    type="default"
                    stylingMode="text"
                    onClick={() => {
                      setOpenIdDelete(data.key);
                      setVisibleDelete(true);
                    }}
                  />
                </ClaimsProvider>
              </>
            )}
          />

          <Paging defaultPageSize={15} />
          <Pager showPageSizeSelector={true} allowedPageSizes={[15, 30, 50, 100]} />
        </DataGrid>
      </AppCard>
    </div>
  );
};

export default TransportPage;
